import * as Sentry from '@sentry/browser'
import { Replay } from '@sentry/browser'

import './scss/frontend.scss'

import '@shoelace-style/shoelace/dist/shoelace.js'
import '@shoelace-style/shoelace/dist/themes/light.css'
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js'
import Alpine from 'alpinejs'

import print from 'print-js'

import './js/admin.js'
import './js/frontend.js'

import dayjs from 'dayjs'
import dayjs_plugin_utc from 'dayjs/plugin/utc'
import dayjs_plugin_timezone from 'dayjs/plugin/timezone'
import dayjs_plugin_isBetween from 'dayjs/plugin/isBetween'
import dayjs_plugin_isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import dayjs_plugin_isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

dayjs.extend(dayjs_plugin_utc)
dayjs.extend(dayjs_plugin_timezone)
dayjs.extend(dayjs_plugin_isBetween)
dayjs.extend(dayjs_plugin_isSameOrBefore)
dayjs.extend(dayjs_plugin_isSameOrAfter)
dayjs.tz.setDefault('America/New_York')

window.dayjs = dayjs

setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.20.0/cdn/')

document.addEventListener('DOMContentLoaded', function () {
  if (typeof currentWPUser !== 'undefined' && typeof enableSentry !== 'undefined') {
    const replay = new Replay({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailDenyUrls: ['?bricks=run'],
    })
    Sentry.init({
      dsn: 'https://6936056745c6cdc340783d3510fa389f@o4506569836724224.ingest.sentry.io/4506569838755840',
      release: 'wf-staging',
      integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Feedback({
          colorScheme: 'light',
        }),
        replay
      ],
      tracesSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
    })
    Sentry.setUser({
      email: currentWPUser,
    })
  }

  const links = document.querySelectorAll('.hover-effect')

  const createSpan = (text, className) => {
    const span = document.createElement('span')
    span.textContent = text
    span.classList.add(className)
    return span
  }

  links.forEach(link => {
    const hoverText = link.getAttribute('data-hover')
    const normalText = link.textContent

    link.setAttribute('aria-label', `${normalText}, ${hoverText}`)
    link.textContent = ''
    link.appendChild(createSpan(normalText, 'normal'))
    link.appendChild(createSpan(hoverText, 'hover')).setAttribute('aria-hidden', true)
  })
})

window.Alpine = Alpine
Alpine.start()
